<template>
  <div>
    <section role="form">
      <div class="main-container container">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-content">
                <h4>
                  Contatos
                  <span v-if="cadastrado.mostraMultiplosRegistros">- {{ cadastrado.registro | formataRegistro }}</span>
                </h4>
                <div class="row">
                  <form>
                    <div class="col-md-4">
                      <div class="form-group" v-if="ehEmailPrefeitura">
                        <label for="email">Email</label>
                        <p class="textoAlinhadoAoInput">
                          {{ cadastrado.pessoa.contato.email }}
                        </p>
                      </div>
                      <div class="form-group" v-else>
                        <field-validation label="Email" field="email" :status="errors" :custom-errors="apiErrors"
                          :show-icon="false"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'">
                          <input type="text" name="email" id="email" class="form-control" style="text-transform: none;"
                            v-model="cadastrado.pessoa.contato.email" v-validate="'required|email|max:70'"
                            data-vv-as="Email"
                            :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'">
                        </field-validation>

                      </div>
                    </div>
                    <div class="col-md-1 col-xs-3">
                      <div class="form-group">
                        <label for="dddCelular">DDD</label>
                        <input class="form-control" type="tel" name="dddCelular" id="dddCelular"
                          v-model="cadastrado.pessoa.contato.dddCelular" v-mask="'##'"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'">
                      </div>
                    </div>
                    <div class="col-md-3 col-xs-9">
                      <div class="form-group">
                        <label for="telefoneCelular">Tel Celular</label>
                        <input class="form-control" type="tel" name="telefoneCelular" id="telefoneCelular"
                          v-model="cadastrado.pessoa.contato.numeroCelular" v-mask="'#####-####'"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'">
                      </div>
                    </div>
                    <div class="col-md-1 col-xs-3">
                      <div class="form-group">
                        <label for="dddResidencial">DDD</label>
                        <input class="form-control" type="tel" name="dddResidencial" id="dddResidencial"
                          v-model="cadastrado.pessoa.contato.dddTelefone" v-mask="'##'"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'">
                      </div>
                    </div>
                    <div class="col-md-3 col-xs-9">
                      <div class="form-group">
                        <label for="telefoneResidencial">Tel Fixo</label>
                        <input class="form-control" type="tel" name="telefoneResidencial" id="telefoneResidencial"
                          v-model="cadastrado.pessoa.contato.numeroTelefone" v-mask="'####-####'"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'">
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="controller">
      <div class="container footer-controller">
        <div class="row">
          <div class="col-sm-12 col-md-12">
            <botao estilo="vazado-verde-esq" rotulo="Voltar" icone="voltar" @clicado="volta()" />
            <botao estilo="cheio-verde-dir" rotulo="Avançar" icone="avancar" :icone-direita="true"
              @clicado="avanca(cadastrado, 'Documentacao')" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue'
import Botao from '@/components/botao'
import StringHelper from '@/helpers/StringHelper'
import NullHelper from '@/helpers/NullHelper'

export default {
  name: 'Contatos',

  data() {
    return {
      cadastrado: this.$store.state.funcionarioCadastrado,
      contato: {
        dddCelular: null,
        dddTelefone: null,
        email: '',
        numeroCelular: null,
        numeroTelefone: null
      },
      apiErrors: null
    }
  },

  computed: {
    telefoneResidencialMasked() {
      let mask = ''
      if (this.cadastrado && this.cadastrado.pessoa.contato.numeroTelefone) {
        mask = this.cadastrado.pessoa.contato.numeroTelefone.length === 10
          ? '#####-####'
          : '####-####?#'
      }
      return mask
    },
    ehEmailPrefeitura() {
      const contatoModelo = this.$store.state.cadastroModelo.pessoa.contato
      if (contatoModelo && contatoModelo.email) {
        return contatoModelo.email.includes('@santos.sp.gov.br')
      }
      return false
    },
    situacaoRecad() {
      return this.$store.getters.getSituacaoRecad;
    },
  },

  methods: {
    volta() {
      this.$validator.validateAll().then(success => {
        if (success) {
          this.$router.go(-1)
        } else {
          this.$root.$refs.toastr.e('Corrija os campos em vermelho', 'Atenção')
        }
      })
    },
    avanca(cadastrado, proximoLink) {
      this.$validator.validateAll().then(success => {
        if (success) {
          if (proximoLink !== 'Contatos') {
            this.formataParaApi(cadastrado)
            this.$store.commit('setFuncionarioCadastrado', cadastrado)
            this.$router.push({ name: proximoLink })
          }
        } else {
          this.$root.$refs.toastr.e('Corrija os campos em vermelho', 'Atenção')
        }
      })
    },
    valoraNulos(pessoa) {
      pessoa.contato = NullHelper.valora(pessoa.contato, this.contato)
    },
    resetaNulos(pessoa) {
      pessoa.contato = NullHelper.reseta(pessoa.contato, this.contato)
    },
    formataParaApi(cadastrado) {
      let contato = cadastrado.pessoa.contato
      if (contato) {
        const limpa = numero => StringHelper.limpaFormato(numero)
        const numerifica = numero => numero ? parseInt(numero) : null

        contato.numeroTelefone = limpa(contato.numeroTelefone)
        contato.numeroTelefone = numerifica(contato.numeroTelefone)
        contato.numeroCelular = limpa(contato.numeroCelular)
        contato.numeroCelular = numerifica(contato.numeroCelular)
        contato.dddTelefone = numerifica(contato.dddTelefone)
        contato.dddCelular = numerifica(contato.dddCelular)

        // Garante que o email não seja vazio ou apenas espaços
        if (contato.email) {
          contato.email = contato.email.trim()
          this.tiraAcentuacao(contato)
        }
      }
      this.resetaNulos(cadastrado.pessoa)
    },
    tiraAcentuacao(contato) {
      if (StringHelper.verificaCaracterEspecial(contato.email)) {
        contato.email = StringHelper.limpaCaracterEspecial(contato.email)
        this.$root.$refs.toastr.w('A Atualização Cadastral não aceita acentos e cedilhas. A aplicação já fez as correções necessárias.', 'Atenção')
      }
    },
  },

  created() {
    console.log(this.situacaoRecad);
    this.valoraNulos(this.cadastrado.pessoa)
    this.$eventBus.$on('salvaAvanca', (nomeComponente) => {
      // Validação adicional para garantir que o email não seja nulo antes de permitir avançar
      if (!this.ehEmailPrefeitura) {
        const email = this.cadastrado.pessoa.contato.email
        if (!email || email.trim() === '') {
          this.$root.$refs.toastr.e('O campo Email é obrigatório', 'Atenção')
          this.$router.push({ name: 'Contatos' })
          return
        }
      }
      this.avanca(this.cadastrado, nomeComponente)
    })
  },

  mounted() {
    window.scrollTo(0, 0)
  },

  beforeDestroy() {
    this.$eventBus.$off('salvaAvanca')
  },

  components: {
    Botao
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?1d212354